export default {
  async fetch() {
    this.section = await this.$cachedStrapi
      .find('registration-and-application-dialog')
      .catch((e) => {
        if (e.statusCode !== 404) {
          throw e;
        }
      });
    this.registerAndApplyData.notes =
      this.section.application_default_text
        .replace(/%job_activity/g, this.job.activities || '')
        .replace(/%job_name/g, this.job.name || '')
        .replace(/%job_period/g, this.job.period || '')
        .replace(/%user_name/g, '') || '';
    if (this.section.google_registration) {
      this.loginItems.push({
        title: this.$t('action.apply_with_google'),
        icon: 'fab fa-google',
      });
    }
    if (this.section.apple_registration) {
      this.loginItems.push({
        title: this.$t('action.apply_with_apple'),
        icon: 'fab fa-apple',
      });
    }
    if (this.section.facebook_registration) {
      this.loginItems.push({
        title: this.$t('action.apply_with_facebook'),
        icon: 'fab fa-facebook',
      });
    }
    if (this.section.microsoft_registration) {
      this.loginItems.push({
        title: this.$t('action.apply_with_microsoft'),
        icon: 'fab fa-microsoft',
      });
    }
    this.registerAndApplyData.advertisingConsent = this.section
      .checkbox_advertising_consent
      ? false
      : null;
    this.organizationLinkText = this.section.checkbox_organization_link;
    let organizationId = '';
    if (this.$cookies.get('organization_parameter')) {
      organizationId = this.$cookies.get('organization_parameter').id;
    } else if (
      this.$route.query.organization_id &&
      this.$route.query.mtm_source &&
      this.$route.query.mtm_medium &&
      this.$route.query.mtm_group
    ) {
      organizationId = this.$route.query.organization_id;
    }
    if (organizationId != '') {
      await this.$store
        .dispatch('api/organization/getOrganization', {
          id: organizationId,
        })
        .then((result) => {
          this.currentOrganization = result;
        });
    }
    if (this.currentOrganization && this.organizationLinkText) {
      this.organizationLinkText = this.organizationLinkText.replace(
        /%company_name/g,
        this.currentOrganization.name
      );
    }
  },
  computed: {
    organizationAvailable() {
      let organizationId = '';
      if (this.$cookies.get('organization_parameter')) {
        organizationId = this.$cookies.get('organization_parameter').id;
      } else if (
        this.$route.query.organization_id &&
        this.$route.query.mtm_source &&
        this.$route.query.mtm_medium &&
        this.$route.query.mtm_group
      ) {
        organizationId = this.$route.query.organization_id;
      }
      return this.job.organization.id === organizationId;
    },
  },
};
